import { store } from './store';
import authActions from './auth/actions';
import { setAppSettings } from '@helpers/utility';

export default () =>
  new Promise(() => {
    setAppSettings();
    store.dispatch(authActions.checkAuthorization());
  });
